<template>
  <div class="itemDetail" v-if="item.item_id">
    <div class="itemDetail__item">
      <div class="itemDetail__item__thumbnail">
        <img :src="item.pack_image" alt="" />
      </div>
      <div class="itemDetail__item__wrapper">
        <p class="itemDetail__item__wrapper__title">
          <span>NEW</span>{{ item.item_name }}
        </p>
        <ul class="itemDetail__item__wrapper__tag">
          <li class="itemDetail__item__wrapper__tag__list" v-if="item.service_type_str">{{ item.service_type_str }}</li>
        </ul>
        <p class="itemDetail__item__wrapper__price">¥{{ item.price_taxin | addComma }}<span>(税込)</span></p>
      </div>
    </div>
    <a :href="`/movie/custom/26/profile/${id}${getQuery()}`" class="itemDetail__button">購入へ進む</a>
  </div>
</template>

<script>
export default {
  name: 'item-link',
  data() {
    return {
      item: {
        item_id: 0,
        item_name: '',
        pack_image: '',
        service_type_str: '',
        price_taxin: 0
      }
    };
  },
  props: {
    id: { type: Number, default: 0 },
    cpno: { type: Number, default: 0 }
  },
  mounted() {
    if (!this.id) return;

    axios
      .post('/api/items/getitem', { id: this.id })
      .then(content => content.data)
      .then(item => (this.item = item));
  },
  methods: {
    getQuery() {
      return this.cpno ? `?cpno=${this.cpno}` : '';
    }
  }
};
</script>

<style lang="scss">
@import '../../../sass/variables/colors.scss';

.itemDetail {
  &__item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
    background: white;
    &__thumbnail {
      margin-right: 12px;
      img {
        display: block;
        width: 125px !important;
        height: auto;
      }
    }
    &__wrapper {
      width: calc(100% - 137px);
      &__title {
        line-height: 1.26;
        margin: 0;
        font-size: 15px;
        font-weight: bold;
        color: black;
        span {
          margin-right: 4px;
          font-size: 12px;
          color: $brand-2;
        }
      }
      &__description {
        margin-top: 8px !important;
        line-height: 1.33;
        font-size: 12px;
      }
      &__tag {
        display: flex;
        align-items: center;
        list-style: none;
        margin-top: 8px;
        padding: 0;
        &__list {
          line-height: 16px;
          padding: 0 2px;
          font-size: 10px;
          text-align: center;
          color: black;
          border: 1px solid black;
          &:nth-of-type(n + 2) {
            width: 86px;
            margin-left: 4px;
          }
        }
      }
      &__price {
        position: absolute;
        right: 0;
        bottom: 0;
        line-height: 1;
        margin: 0;
        font-size: 18px;
        font-weight: bold;
        color: $brand-2;
        span {
          font-size: 12px;
        }
      }
    }
  }
  &__button {
    display: block;
    line-height: 50px;
    margin-top: 16px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    text-decoration: none;
    color: white;
    background: linear-gradient(180deg, #fd569f 0%, #ed1e79 53.04%, #df0364 100%);
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ItemLink.vue